import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  add_hygiene_task_categories,
  update_hygiene_task_categories,
} from "../../../data/ApiEndpoints";
import { validationHygieneTaskCategoryForm } from "../hygiene-common/validation";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";

const TaskCategoryForm = ({
  userInfoData,
  callFunction,
  isEdit,
  rowData,
  closeModal,
  isCRUD,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    categoryName: isEdit && rowData?.name ? rowData.name : "",
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validationHygieneTaskCategoryForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? update_hygiene_task_categories
      : add_hygiene_task_categories;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.categoryName,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Check Before Submit.`,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Task Category`
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className={`createNewCTOModalContainer mod-width-50p`}>
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Task Category`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Add"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="categoryName" className={`formInputLabel `}>
              task category name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Category name"
              className={`formInput ${
                formErrors?.categoryName ? "formError" : ""
              }`}
              name="categoryName"
              value={formValues.categoryName}
              onChange={onChangeInput}
            />
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={`Active`}
              className={`hygine-label ${formValues.isActive ? "active" : ""}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
              disabled={!isCRUD}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default TaskCategoryForm;
